// extracted by mini-css-extract-plugin
export var infoItem = "_qk-2";
export var title = "_qk-0";
export var value = "_qk-1";